module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('button', {
    staticClass: "nav right",
    class: {
      disabled: _vm.noshow === true
    },
    on: {
      "click": _vm.next
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e3aef84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 144
// module chunks = 0